import FullScreenCode from '../domains/squads/components/FullScreenCode';

const FullScreenCodePage = () => {
  return <FullScreenCode />;
};

export default FullScreenCodePage;
